import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ToastCustom.css';

import Header from './components/Header';
import MenuLateral from './components/MenuLateral';
import Dashboard from './pages/Dashboard';

import Login from './pages/Login';
import CadastroLead from './pages/CadastroLead';
import ListagemLeads from "./pages/ListagemLeads";
import EditarLead from "./pages/EditarLead";
import ListagemAcoes from "./pages/ListagemAcoes";
import RevisaoObjecoes from "./pages/RevisaoObjecoes";
import CriarAcao from "./pages/CriarAcao";
import Relatorios from "./pages/Relatorios";
import ExportarDados from "./pages/ExportarDados";
import Ajuda from "./pages/Ajuda";
import RecuperarSenha from "./pages/RecuperarSenha";
import RedefinirSenha from "./pages/RedefinirSenha";
import EditarAcao from "./pages/EditarAcao";
import AlterarSenha from "./pages/AlterarSenha";
import EditarMeusDados from "./pages/EditarMeusDados";
import GerenciarUsuarios from "./pages/GerenciarUsuarios";
import EditarUsuario from "./pages/EditarUsuario";
import AdicionarUsuario from "./pages/AdicionarUsuario";
import UsuarioConfig from "./pages/UsuarioConfig";
import OpiniaoUsuario from "./pages/OpiniaoUsuario";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import NoreaCRM from './pages/NoreaCRM';
import ListarCobrancas from "./pages/Financeiro/ListarCobrancas";
import DetalhesCobranca from "./pages/Financeiro/DetalhesCobranca";
import CriarCobranca from "./pages/Financeiro/CriarCobranca";
import AssociarPagamento from "./pages/Financeiro/AssociarPagamento";
import 'bootstrap/dist/css/bootstrap.min.css';
import CalculoComissoes from './pages/Financeiro/CalculoComissoes';
import ListarDataCobranca from './pages/Financeiro/ListarDataCobranca';
import PrevisaoRecebimentos from './pages/Financeiro/PrevisaoRecebimentos';
import IntegrarWhatsApp from './pages/WhatsApp/IntegrarWhatsApp';
import PainelWhatsApp from './pages/WhatsApp/PainelWhatsApp';
import PainelMensagens from './pages/WhatsApp/PainelMensagens';
import PainelMensagensTESTE from './pages/WhatsApp/PainelMensagensTESTE';
import FilaMensagens from './pages/WhatsApp/FilaMensagens';
import PainelInstancias from './pages/WhatsApp/PainelInstancias';
import RespostasRapidas from './pages/WhatsApp/RespostasRapidas';
import CriarNotaFiscal from './pages/Financeiro/CriarNotaFiscal';
import NotasFiscais from './pages/Financeiro/NotasFiscais';
import SaldoAsaas from './pages/Financeiro/SaldoAsaas';
import Checkout from './pages/Financeiro/Checkout';
import CheckoutI9 from './pages/Financeiro/CheckoutI9';
import CheckoutImpactus from './pages/Financeiro/CheckoutImpactus';

import GerenciarTags from './pages/GerenciarTags';
import LeadDetalhes from './pages/LeadDetalhes';
import ListarVinculos from './pages/Meta/ListarVinculos';
import VincularContasMeta from './pages/Meta/VincularContasMeta';
import RelatorioMeta from './pages/Meta/RelatorioMeta';
import ResumoFinanceiroMeta from './pages/Meta/ResumoFinanceiroMeta';
import IARecomendacoesMeta from './pages/OpenAi/IARecomendacoesMeta';
import Biblioteca from './pages/OpenAI/Biblioteca';
import BloqueadosIA from './pages/OpenAI/BloqueadosIA';
import ConfiguracoesIA from './pages/OpenAI/ConfiguracoesIA';
import LogsIA from './pages/OpenAI/LogsIA';
import PainelIA from './pages/OpenAI/PainelIA';
import PendenciasIA from './pages/OpenAI/PendenciasIA';
import PainelFunil from './pages/Funil/PainelFunil';

import IntegracaoGoogleAds from './pages/GoogleAds/IntegracaoGoogleAds';
import RelatorioGoogleAds from './pages/GoogleAds/RelatorioGoogleAds';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const audioRef = useRef(null);

  const location = useLocation();

  useEffect(() => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'page_view',
    page_path: location.pathname,
    page_title: document.title
  });

}, [location]);

  const PUBLIC_ROUTES = ["/login", "/recuperar-senha", "/redefinir-senha", "/checkouti9", "/checkout-impactus", "/checkout", "/politica-privacidade", "/norea-crm"];


  // Verificação de autenticação
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch('https://welaunchyou.com.br/crm-wly/checkAuth.php', {
          credentials: 'include',
        });

        if (response.ok) {
          const data = await response.json();
          if (data.error) throw new Error(data.error);
          setIsAuthenticated(true);
          setIsAdmin(data.tipo_usuario === 'master');
          localStorage.setItem('isAuthenticated', 'true');
          localStorage.setItem('isAdmin', data.tipo_usuario === 'master' ? 'true' : 'false');
          localStorage.setItem('usuario', JSON.stringify(data));
        } else {
          throw new Error("Usuário não autenticado");
        }
      } catch {
        setIsAuthenticated(false);
        setIsAdmin(false);
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('usuario');
      } finally {
        setIsLoading(false);
      }
    };

const pathnameNormalizado = location.pathname.replace(/\/+$/, '') || '/';

if (PUBLIC_ROUTES.includes(pathnameNormalizado)) {
  setIsLoading(false);
  return;
}
    checkAuth();
  }, [location.pathname]);

  // Verificação periódica de pendências IA
  useEffect(() => {
    const verificarPendenciasIA = async () => {
      const usuario = JSON.parse(localStorage.getItem('usuario'));
      if (!usuario?.id) return;

      const notificacoesAtivas = localStorage.getItem('notificacoes_pendencias') !== 'off';
      const somAtivo = localStorage.getItem('som_pendencias') !== 'off';

      try {
        const res = await fetch(`https://welaunchyou.com.br/crm-wly/api/openai/pendencias_ia.php?usuario_id=${usuario.id}`, {
          credentials: 'include',
        });
        const data = await res.json();
        if (data.success && Array.isArray(data.pendencias) && data.pendencias.length > 0 && notificacoesAtivas) {
if (somAtivo) {
  const audio = new Audio("/crm-wly/sounds/alerta.mp3");
  audio.play().catch(() => {});
}
          toast.warning(`⚠️ Você tem ${data.pendencias.length} pendência(s) da IA para assumir.`, { position: "top-right" });
        }
      } catch {}
    };

    if (isAuthenticated) {
      verificarPendenciasIA();
      const intervalo = setInterval(verificarPendenciasIA, 60 * 1000);
      return () => clearInterval(intervalo);
    }
  }, [isAuthenticated]);



  const handleLogout = async () => {
    try {
      const response = await fetch('https://welaunchyou.com.br/crm-wly/logout.php', {
        method: 'POST',
        credentials: 'include'
      });
      if (response.ok) {
        localStorage.clear();
        setIsAuthenticated(false);
        setIsAdmin(false);
        window.location.href = '/crm-wly/login';
      }
    } catch {}
  };

  if (isLoading) return <div>Carregando...</div>;

  return (
    <>
      <div className={`App ${isAuthenticated ? 'has-sidebar' : ''}`} style={{ display: 'flex', height: '100vh' }}>
        {isAuthenticated && <MenuLateral isAdmin={isAdmin} handleLogout={handleLogout} />}

        {/* Este container recebe o margin-left via CSS global */}
        <div className="main-content" style={{ flex: 1, padding: '20px' }}>
          {isAuthenticated && <Header handleLogout={handleLogout} />}

          <Routes>
            {!isAuthenticated ? (
              <>
                {/* ROTAS PÚBLICAS */}
                <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} setIsAdmin={setIsAdmin} />} />
                <Route path="/recuperar-senha" element={<RecuperarSenha />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkouti9" element={<CheckoutI9 />} />
                <Route path="/checkout-impactus" element={<CheckoutImpactus />} />
                <Route path="/redefinir-senha" element={<RedefinirSenha />} />
                <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
                <Route path="/norea-crm" element={<NoreaCRM />} />

                <Route path="*" element={<Navigate to="/login" replace />} />
              </>
            ) : (
              <>
                {/* ROTAS PRIVADAS */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/cadastro-lead" element={<CadastroLead />} />
                <Route path="/editar-lead/:lead_id" element={<EditarLead />} />
                <Route path="/listagem-leads" element={<ListagemLeads />} />
                <Route path="/acoes" element={<ListagemAcoes />} />
                <Route path="/criar-acao/:leadId" element={<CriarAcao />} />
                <Route path="/criar-acao/" element={<CriarAcao />} />
                <Route path="/editar-acao/:acaoId" element={<EditarAcao />} />
                <Route path="/revisao-objecoes" element={<RevisaoObjecoes />} />
                <Route path="/relatorios" element={<Relatorios />} />
                <Route path="/exportacao-dados" element={<ExportarDados />} />
                <Route path="/ajuda-suporte" element={<Ajuda />} />
                <Route path="/alterar-senha" element={<AlterarSenha />} />
                <Route path="/meus-dados" element={<EditarMeusDados />} />
                <Route path="/opiniao" element={<OpiniaoUsuario />} />
                <Route path="/gerenciar-tags" element={<GerenciarTags />} />
                <Route path="/lead-detalhes/:lead_id" element={<LeadDetalhes />} />
                <Route path="/meta/relatorio-meta" element={<RelatorioMeta />} />
                <Route path="/meta/saldo-meta" element={<ResumoFinanceiroMeta />} />
                <Route path="/wzp/integrar-wzp" element={<IntegrarWhatsApp />} />
                <Route path="/wzp/painel-whatsapp" element={<PainelWhatsApp />} />
                <Route path="/wzp/painel-mensagens" element={<PainelMensagens />} />
                <Route path="/wzp/painel-mensagens-teste" element={<PainelMensagensTESTE />} />

                <Route path="/googleads/integracao-googleads" element={<IntegracaoGoogleAds />} />
                <Route path="/googleads/relatorio-googleads" element={<RelatorioGoogleAds />} />


                <Route path="/wzp/fila-mensagens" element={<FilaMensagens />} />
                <Route path="/wzp/respostas-rapidas" element={<RespostasRapidas />} />
                <Route path="/gerenciar-usuarios" element={<GerenciarUsuarios />} />
                <Route path="/adicionar-usuario" element={<AdicionarUsuario />} />
                <Route path="/usuario-config" element={<UsuarioConfig />} />
                <Route path="/editar-usuario/:id" element={<EditarUsuario />} />
                <Route path="/listar-cobrancas" element={<ListarCobrancas />} />
                <Route path="/financeiro/detalhes/:id" element={<DetalhesCobranca />} />
                <Route path="/financeiro/criar-cobranca" element={<CriarCobranca />} />
                <Route path="/financeiro/associar-pagamento" element={<AssociarPagamento />} />
                <Route path="/financeiro/calculo-comissoes" element={<CalculoComissoes />} />
                <Route path="/financeiro/listar-data-cobranca" element={<ListarDataCobranca />} />
                <Route path="/financeiro/previsao-recebimentos" element={<PrevisaoRecebimentos />} />
                <Route path="/financeiro/criar-nota" element={<CriarNotaFiscal />} />
                <Route path="/financeiro/notas" element={<NotasFiscais />} />
                <Route path="/financeiro/saldo-asaas" element={<SaldoAsaas />} />
                <Route path="/meta/listar-vinculos" element={<ListarVinculos />} />
                <Route path="/meta/vincular-contas-meta" element={<VincularContasMeta />} />
                <Route path="/openai/iarecomendacoes-meta" element={<IARecomendacoesMeta />} />
                <Route path="/wzp/painel-instancias" element={<PainelInstancias />} />
                <Route path="/openai/biblioteca" element={<Biblioteca />} />
                <Route path="/openai/bloqueados" element={<BloqueadosIA />} />
                <Route path="/openai/configuracoes" element={<ConfiguracoesIA />} />
                <Route path="/openai/recomendacoes-meta" element={<IARecomendacoesMeta />} />
                <Route path="/openai/logs" element={<LogsIA />} />
                <Route path="/openai/painel" element={<PainelIA />} />
                <Route path="/openai/pendencias" element={<PendenciasIA />} />
                <Route path="/funil/painel-funil" element={<PainelFunil />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </>
            )}
          </Routes>
        </div>

        <ToastContainer position="top-right" autoClose={8000} hideProgressBar={false} newestOnTop />
      </div>
    </>
  );
}

export default function AppWithRouter() {
  // PRE-REDIRECT: aceita links com hash antes do Router montar.
  if (typeof window !== "undefined") {
    const h = window.location.hash;
    if (h && (h.startsWith("#/redefinir-senha") || h.startsWith("#/recuperar-senha"))) {
      const dest = "/crm-wly" + h.slice(1);
      const current = window.location.pathname + window.location.search;
      if (current !== dest) {
        window.location.replace(dest);
        return null;
      }
    }
  }

  return (
    <Router basename="/crm-wly">
      <App />
    </Router>
  );
}
